var _circle, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerificationLinkExpired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 50,
    stroke: "#E7E7E7",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 67,
    width: 5,
    height: 44,
    rx: 2,
    transform: "rotate(-180 55.5 67)",
    fill: "#5A5C5E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 83,
    width: 5,
    height: 8,
    rx: 2,
    transform: "rotate(-180 55.5 83)",
    fill: "#5A5C5E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationLinkExpired);
export default __webpack_public_path__ + "static/media/verification-link-expired.bd81416939bb343a3e805cc7238a204e.svg";
export { ForwardRef as ReactComponent };